import { render, staticRenderFns } from "./CatalogPricing.vue?vue&type=template&id=560327b9&scoped=true"
import script from "./CatalogPricing.vue?vue&type=script&lang=js"
export * from "./CatalogPricing.vue?vue&type=script&lang=js"
import style0 from "./CatalogPricing.vue?vue&type=style&index=0&id=560327b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560327b9",
  null
  
)

export default component.exports